import api from "../../../store/AuthHeader";

const getAllEmployersForReport = () => {
    return api.get("/Report/GetEmployersForReport");
};

const getOverviewDetails = (payload : any) => {
    return api.post("/Report/GetOverviewDetails", payload);
};

const CheckIfReportDataExists = (payload: any) => {
    return api.post("/Report/CheckIfReportDataExists", payload);
};

const getAverageWeekDetails = (payload: any) => {
    return api.post("/Report/GetAverageWeekDetails", payload);
};

const getDutyDayDetailsForReport = (payload:any) => {
    return api.post(`/Report/GetDutyOncallDetails`, payload);
};

const getWeeklyBreakdownDetails = (payload: any) => {
    return api.post("/Report/GetWeeklyBreakdownDetails", payload)
}

const getTargetDetails = (payload: any) => {
    return api.post("/Report/GetTargetDetails", payload);
};

const updateTargetDetails = (payload: any) => {
    return api.post("/Report/UpdateSetTargets", payload);
};

const SaveReportsPdf = (payload: any) => {
    return api.post("/Report/SaveReportsPdf", payload);
};

export default {
    getAllEmployersForReport,
    getOverviewDetails,
    CheckIfReportDataExists,
    getAverageWeekDetails,
    getDutyDayDetailsForReport,
    getWeeklyBreakdownDetails,
    getTargetDetails,
    updateTargetDetails,
    SaveReportsPdf
};